export default __webpack_public_path__ + "static/media/AVAX.73b3f250.png";